export interface PasswordRequirements {
  minLength: boolean;
  hasLowercase: boolean;
  hasUppercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}

export const validatePassword = (password: string): PasswordRequirements => {
  return {
    minLength: password.length >= 8,
    hasLowercase: /[a-z]/.test(password),
    hasUppercase: /[A-Z]/.test(password),
    hasNumber: /\d/.test(password),
    hasSpecialChar: /[\^\$\*\.\[\]\{\}\(\)\?\"\!@#%&\/\\,><':;|_~=+\-`]/.test(password),
  };
};

export const isPasswordValid = (requirements: PasswordRequirements): boolean => {
  return Object.values(requirements).every(Boolean);
};

export const getPasswordStrength = (requirements: PasswordRequirements): 'weak' | 'fair' | 'good' | 'strong' => {
  const metRequirements = Object.values(requirements).filter(Boolean).length;
  
  if (metRequirements <= 2) return 'weak';
  if (metRequirements === 3) return 'fair';
  if (metRequirements === 4) return 'good';
  return 'strong';
};